import { typography } from '@client/theme/typography';
import type { ThemeOptions } from '@mui/material';

const Breadcrumbs: ThemeOptions['components'] = {
  MuiBreadcrumbs: {
    styleOverrides: {
      separator: {
        ...typography.caption,
      },
    },
  },
};

export default Breadcrumbs;
